var $c57956343a705d69$exports = {};
$c57956343a705d69$exports = {
    "replaceMessage": `\u{5220}\u{9664}\u{8981}\u{66FF}\u{6362}\u{7684}\u{6587}\u{4EF6}`
};


export {$c57956343a705d69$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
